import React from 'react';
import PropTypes from 'prop-types';

import GameMaterialItem from './GameMaterialItem';
import AudioGameMaterial from './AudioGameMaterial';
import PasswordGameMaterial from './PasswordGameMaterial';
import DocumentGameMaterial from './DocumentGameMaterial';
import VideoGameMaterial from './VideoGameMaterial';
import SoftwareGameMaterial from './SoftwareGameMaterial';
import DownloadAudioButton from './DownloadAudioButton';
import LinkMaterialItem from './LinkMaterialItem';
import apiCall from '../apiCall';
import { connect } from 'react-redux';

class GameMaterials extends React.Component {
  constructor(props) {
    super(props);
    console.log("props:", props);
    this.state = {
      desktop: (window.innerWidth >= 1240),
      areBonuscardsEnabled: null,
      enabledGames: [],
      fetchingAdditionalFilterData: false,
      fetchedAdditionalFilterData: false,
    };
  }

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }
  static defaultProps = {
    items: [],
  }

  fetchAdditionalFilterData = () => {
    console.log("Fetch additional filter data");
    const projectId = this.props.project && this.props.project.id ? this.props.project.id : this.props.projectId;
    console.log("project id:", projectId);
    if (projectId && !this.state.fetchingAdditionalFilterData && !this.state.fetchedAdditionalFilterData) {
      this.setState({ fetchingAdditionalFilterData: true });
      apiCall(`/project/${projectId}/additionalGameMaterialFilterData`).then(({ areBonuscardsEnabled, enabledGames }) => {
        this.setState({ areBonuscardsEnabled, enabledGames });
      }
      )
        .catch((err) => {
          console.log(err);
        }
        )
        .finally(() => {
          this.setState({ fetchingAdditionalFilterData: false, fetchedAdditionalFilterData: true });
        }
        );
    }
  };
  componentDidMount() { this.fetchAdditionalFilterData() }
  componentDidUpdate() { this.fetchAdditionalFilterData() }

  renderMaterialItem = (item) => {
    switch (item.type) {
      case 'software':
        return <SoftwareGameMaterial {...this.props} item={item} />;
      case 'video':
      case 'vimeo':
        return <VideoGameMaterial {...this.props} item={item} />;
      case 'file':
        if (item.Material && item.Material.mimeType.includes('pdf')) {
          return <DocumentGameMaterial {...this.props} item={item} />
        } else if (item.Material && item.Material.mimeType.includes('audio')) {
          return <AudioGameMaterial {...this.props} item={item} />
        } else if (item.Material && item.Material.mimeType.includes('video')) {
          return <VideoGameMaterial {...this.props} item={item} />;
        } else if (!item.Material && item.alternateUrl) {
          return <VideoGameMaterial {...this.props} item={item} />;
        }
        break;
      case 'link':
        return <LinkMaterialItem {...this.props} item={item} />;
      case 'password':
        return <PasswordGameMaterial {...this.props} item={item} />;
      default:
        return <GameMaterialItem {...this.props} item={item} />;
    }
  };
  render() {
    if (this.state.fetchingAdditionalFilterData) return null;
    console.log(this.state.areBonuscardsEnabled, this.state.enabledGames);
    return (
      <div className={`list-item-container`}>
        {this.props.items
          .filter((item) => { // areBonuscardsEnabled filter
            if (item.bonuscardSettingFilter === 0) return true;
            if (this.state.areBonuscardsEnabled === null) return false;
            if (item.bonuscardSettingFilter === 1) return this.state.areBonuscardsEnabled;
            if (item.bonuscardSettingFilter === 2) return !this.state.areBonuscardsEnabled
            return true;
          })
          // filter based on lite field on project
          .filter((item) => { // basicLiteSettingFilter filter
            if (item.basicLiteSettingFilter === 0) return true;
            if (this.props.project.lite === null) return false;
            if (item.basicLiteSettingFilter === 1) return this.props.project.lite;
            if (item.basicLiteSettingFilter === 2) return !this.props.project.lite
            return true;
          })
          .filter((item) => { // enabledGames filter
            console.log(item.showIfGameIsIncluded); // abbreviation
            if (!item.showIfGameIsIncluded) return true;
            if (this.state.enabledGames === null || !this.state.enabledGames.length) return false;
            return this.state.enabledGames.includes(item.showIfGameIsIncluded.toUpperCase());
          })
          .map((item) => {
            // console.log(item);
            return (
              <span key={item.id}>
                {this.renderMaterialItem(item)}
              </span>
            );
          })}
        {(this.props.gameId === 4 || this.props.gameId === 11) && (!navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) ? ( // Only applies for Escape Route and True Comics
          <DownloadAudioButton
            audio={this.props.items.filter(i => i.Material && i.Material.mimeType.includes('audio')).map(i => i.Material.url)}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
}))(GameMaterials);



// WEBPACK FOOTER //
// ./src/components/elements/GameMaterials.js